import React, { useEffect, useState } from 'react';
import ReactPlayer from "react-player";
import { Card, Col, Container, Row } from 'react-bootstrap'

// videos
import { useNavigate } from 'react-router-dom';
import Loading from '../../../../components/common/Loading';

const VideoViewer = () => {
    const [loading, setLoading] = useState(false);
    const [courseLoaded, setCourseLoaded] = useState(false);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [curVideoIndex, setCurVideoIndex] = useState(0);
    const CourseVideos = selectedCourse?.videos;
    // const { state } = useLocation();
    const navigate = useNavigate();


    const handlePrev = () => {
        setLoading(true);
        setCurVideoIndex(prev => {
            if (prev > 0) {
                return prev - 1;
            }
            return prev;
        });
        setTimeout(() => setLoading(false), 1000);
    }

    const handleNext = () => {
        setLoading(true);
        setCurVideoIndex(prev => {
            if (prev < selectedCourse?.videos?.length - 1) {
                return prev + 1;
            }
            return prev;
        });
        setTimeout(() => setLoading(false), 1000);
    }

    const handleSessionComplete = () => {
        alert("Session Completed");
        setTimeout(() => navigate("/online-training"), 500);
    }

    useEffect(() => {
        const storedCourse = localStorage.getItem("current-course");
        if (storedCourse) {
            setSelectedCourse(JSON.parse(storedCourse));
        };
        setCourseLoaded(true);
    }, []);

    useEffect(() => {
        if (courseLoaded && !selectedCourse) { window.location.href = "/online-training" }
    }, [selectedCourse, courseLoaded]);


    // console.log(selectedCourse)
    // console.log(curVideoIndex, CourseVideos);

    if (!selectedCourse) return;
    return (
        <div id="content-page" className="content-inner py-3 px-0">
            <Container className='px-2'>
                <Row className="gap-0 px-2" style={{ height: "max-content" }} >
                    {/* --- Back Button --- */}
                    <Col className='text-end mb-3'>
                        <button type="button" className="btn btn-primary px-3" onClick={() => navigate("/online-training")}><i className="bi bi-arrow-left me-2"></i>Back to All Courses</button>
                    </Col>
                    <Col className='p-0 col-12'>
                        <Card className="shadow-sm border-0 rounded-3 overflow-hidden px-3 px-lg-4 py-3 fw-bold text-black">
                            {selectedCourse?.title} &nbsp; - &nbsp; "Part-{curVideoIndex + 1}"
                        </Card>
                    </Col>
                    <Col className='video-container p-0 col-12 ' style={{ height: "max-content" }}>
                        {loading ?
                            <div className="w-100 p-0 bg-body-secondary d-flex align-items-center justify-content-center" style={{ height: '40vh' }}><Loading /></div>
                            : CourseVideos?.length > 0
                                ?
                                <ReactPlayer
                                    src={CourseVideos[curVideoIndex] || ""}
                                    autoPlay={true}
                                    controls={true}
                                    className='videoArea w-100 h-auto p-0 rounded-3'
                                />
                                : <div className={"w-100 py-5 text-center"}>No Video Lecture Available </div>
                        }
                    </Col>
                    {CourseVideos?.length > 0 && (
                        <Col className='col-12 p-0 text-end mt-3 d-flex gap-2 align-items-center justify-content-end' >
                            <div>
                                <button type="button" className="btn btn-primary px-4  " disabled={curVideoIndex === 0} onClick={handlePrev}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-double-left me-2" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M8.354 1.646a.5.5 0 0 1 0 .708L2.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0" />
                                        <path fill-rule="evenodd" d="M12.354 1.646a.5.5 0 0 1 0 .708L6.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0" />
                                    </svg>Prev
                                </button>
                            </div>
                            <div>
                                <button type="button" className="btn btn-primary px-4 " disabled={curVideoIndex === CourseVideos?.length - 1} onClick={handleNext} >Next
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-double-right ms-2" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                        <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                    </svg>
                                </button>
                            </div>
                            {(curVideoIndex == CourseVideos?.length - 1) && (
                                <div>
                                    <button type="button" className="btn btn-secondary py-2 px-4 " onClick={handleSessionComplete}>
                                        Session Complete
                                    </button>
                                </div>
                            )}
                        </Col>
                    )}
                </Row>
            </Container>
        </div>
    )
}

export default VideoViewer